import React from "react";

// components
import { KanbanCardJob } from "./card.job";

export const KanbanStageJobStatus = (props) => {
  // Receive information from board.jobs.jsx
  const {
    title,
    jobs = [],
    escalated = false,
  } = props;

  return (
    <div
      className={`w-64 flex-none p-3 rounded-lg border min-h-96 ${
        escalated
          ? "bg-red-50 border-red-300"
          : "bg-slate-100 border-gray-200"
      }`}
    >
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-bold mb-2">{title}</h3>

        <button className="block md:hidden text-blue-500 cursor-pointer">
          All List &rarr;
        </button>
      </div>

      <div className="flex overflow-x-auto space-x-2 md:flex-col md:space-y-2 md:space-x-0">
        {jobs.map((item) => (
          <KanbanCardJob
            key={item.job_id}
            {...item}
            escalated={escalated}
          />
        ))}
      </div>
    </div>
  );
};
